module.exports = __webpack_public_path__ + "img/logo-2.df4b49c6.png";